var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-20 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212529",
    d: "M-5.807 17.943a.625.625 0 0 0 0-.885L-12.865 10l7.058-7.057a.626.626 0 0 0-.885-.885l-7.5 7.5a.626.626 0 0 0 0 .885l7.5 7.5a.623.623 0 0 0 .885 0"
  })));
};
export default SvgChevronLeft;